// Exports
export default {
	"Participant": "Participant_Oan20",
	"Participant_fromOverlay": "Participant_fromOverlay_kHRDL",
	"Participant__inner": "Participant__inner_mbHyl",
	"Participant_dominant": "Participant_dominant_LGlf-",
	"Participant__inner_showNameOnHover": "Participant__inner_showNameOnHover_JTicB",
	"Participant__videoContainer": "Participant__videoContainer_gW82a",
	"ContentWrapper": "ContentWrapper_TOENX",
	"avatarWithNameBlock": "avatarWithNameBlock_wGmgD",
	"Participant__video": "Participant__video_J1-3z",
	"Participant__video_mirror": "Participant__video_mirror_pcd3I",
	"Participant_presenter": "Participant_presenter_9UEUT",
	"Participant_isVideoOn": "Participant_isVideoOn_44-uB",
	"ScreenSharing": "ScreenSharing_zVm4E",
	"isPresenterVideoOn": "isPresenterVideoOn_jFe-Q",
	"Participant__inner_presenter": "Participant__inner_presenter_9jxy8",
	"avatarWrapper": "avatarWrapper_VL-Dg",
	"withoutName": "withoutName_ZDDKG",
	"ChildrenWrapper": "ChildrenWrapper_zvUMV",
	"Participant_presenter_mini": "Participant_presenter_mini_lCloC",
	"Participant_oneOnOne": "Participant_oneOnOne_urFtV",
	"avatarWithNameBlock__content": "avatarWithNameBlock__content_jj7GL",
	"avatarWithNameBlock__avatar": "avatarWithNameBlock__avatar_-Hwva",
	"avatarWithNameBlock__name": "avatarWithNameBlock__name_19KF2",
	"avatarBlockWithMargin": "avatarBlockWithMargin_2eUyM",
	"Participant_img": "Participant_img_qPx4l",
	"Participant_PlaceholderImage": "Participant_PlaceholderImage_iR8-m",
	"Participant_PlaceholderSvg": "Participant_PlaceholderSvg_68mD2",
	"Participant_PlaceholderSvg_Visible": "Participant_PlaceholderSvg_Visible_LEIMp",
	"fullscreenButton": "fullscreenButton_UW0hZ",
	"Participant_moderationPopup": "Participant_moderationPopup_tSlLN",
	"Participant_moderator": "Participant_moderator_iepIq",
	"Participant_scrollSnapAlignStart": "Participant_scrollSnapAlignStart_-ihZH",
	"Participant_scrollSnapAlignEnd": "Participant_scrollSnapAlignEnd_muo0T",
	"Participant_scrollSnapAlignCenter": "Participant_scrollSnapAlignCenter_wLrQF"
};
